import api from './config'

export interface IncomeItem {
  date: string
  category: "other" | "trip" | "tips" | "bonus" | "uber_trip" | "uber_bonus" | "uber_tips"
  amount: number
  reference?: string
  updated_at: string
  sgid: {
    global: string
  }
}

export type IncomeCategory = 'other' | 'trip' | 'tips' | 'bonus' | 'uber_trip' | 'uber_bonus' | 'uber_tips';

interface IncomeParams {
  income_category_code: IncomeCategory
  amount_cents: number
  currency?: string
  date: string
  reference?: string
  operation?: string
}

interface CreateIncomeResponse {
  id: number
  income_category_id: number
  amount_cents: number
  currency: string
  date: string
  reference?: string
  created_at: string
  updated_at: string
}

interface IndexIncomeResponse {
  incomes: IncomeItem[]
}

interface IndexParams {
  year: number
}

const incomeAPI = {
  index: async ({ year }: IndexParams) => {
    const response = await api.get<IndexIncomeResponse>(`/incomes?year=${year}`)
    return response.data
  },
  show: async (id: string) => {
    const response = await api.get<IncomeItem>(`/incomes/${id}`)
    return response.data
  },
  create: async (data: IncomeParams) => {
    const response = await api.post<CreateIncomeResponse>('/incomes', { income: data })
    return response.data
  },
  update: async (id: string, data: IncomeParams) => {
    const response = await api.put<IncomeItem>(`/incomes/${id}`, { income: data })
    return response.data
  },
  delete: async (id: string) => {
    const response = await api.delete(`/incomes/${id}`)
    return response.data
  },
  deleteMonth: async ({ year, month }: { year: number, month: number }) => {
    const response = await api.delete(`/incomes/destroy_month?year=${year}&month=${month}`)
    return response.data
  }
}

export default incomeAPI